<svelte:options accessors/>
<script>
    import UbicacionTransporte from "../../servicio/UbicacionTransporte.svelte";
    import NauiSelect from "../../../naui/atoms/NauiSelect.svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import UbicacionManejoVertical from "../../servicio/UbicacionManejoVertical.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";

    export let data;

    let tipos_inmueble = [
        {label: 'Casa', value: 'Casa'},
        {label: 'Edificio', value: 'Edificio'}
    ]

    function agregarParada() {
        data.paradas.push({
            ciudad: '',
            tipoInmueble: '',
            piso: 0,
            direccion: '',
            vertical: {
                ascensor: {
                    active: false,
                    piso: 0
                },
                fachada: {
                    active: false,
                    piso: 0,
                    intervalo: 0
                },
                escalera: {
                    active: false,
                    piso: 0,
                    intervalo: 0
                }
            }
        });
        data = data;
    }

    function eliminarParada(index) {
        data.paradas.splice(index, 1);
        data = data;
    }
</script>
<div>
    <fieldset>
        <legend>LOGÍSTICA DE TRANSPORTE</legend>
        <UbicacionTransporte bind:data={data.origen} origen="{true}" {tipos_inmueble}/>
        <hr>
        <UbicacionTransporte bind:data={data.destino} origen="{false}" {tipos_inmueble}/>
        <textarea bind:value="{data.observaciones}"
                  class="naui-input w-100"
                  placeholder="Observaciones adicionales de logística y transporte"></textarea>
    </fieldset>
    <fieldset>
        <legend>Paradas adicionales</legend>
        {#each data.paradas as parada, i}
            <div class="box-l my-1">
                <h3 class="mr-1">Parada {i+1}</h3>
                <NauiButton on:click={eliminarParada.bind(this, i)}
                            caption="Eliminar parada {i+1}"
                            icon="times"
                            mode="stroked"
                            color="accent"/>
            </div>
            <div class="grid-7-5 gap-3">
                <div>
                    <div class="grid-3 gap-1 mb-1">
                        <NauiInput label="Ciudad origen" bind:value={parada.ciudad}/>
                        <NauiSelect label="Tipo de inmueble" bind:value={parada.tipoInmueble} options={tipos_inmueble}/>
                        <NauiInput label="Piso" type="number" bind:value={parada.piso}/>
                    </div>
                    <NauiInput label="Dirección origen" bind:value={parada.direccion}/>
                </div>
                <div>
                    <UbicacionManejoVertical bind:data={parada.vertical}/>
                </div>
            </div>
        {/each}
        <NauiButton on:click={agregarParada}
                    caption="Agregar parada"
                    mode="solid"
                    color="accent"/>
    </fieldset>
</div>